import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";
import FormikSelectInput from "@/components/forms/FormikSelectInput";
import { Form, Formik } from "formik";
import { StyledButton } from "@/components";
import useFetchCommonData from "@/hooks/useFetchCommonData";
import FormikMonthYearPicker from "@/components/forms/FormikMonthYearPicker";
import CommonDataTable from "@/components/dataTableComponents/NewDatatable";
import moment from "moment";
import { toast } from "@/components/toastify";
import { useGetOverrideHistoryQuery, useDeleteOverrideMutation } from "@/api/services/attendanceManagement/muster/Muster";
import dayjs from "dayjs";

const OverrideHistory = () => {

  const [selectedRows, setSelectedRows] = useState([]);
  const [changeValue, setChangeValue] = useState({
    selectEmployee: "",
    selectMonth: moment().format("MM-YYYY"),
  });
  const [dataTableKey, setDataTableKey] = useState(0);
  const [stateData, setStateData] = useState();
  
  const { data: fetchAllEmployees } = useFetchCommonData("EMPLOYEES");
  const { data: rowDetails = [], refetch } =
  useGetOverrideHistoryQuery({
      empId: changeValue?.selectEmployee,
      month: changeValue?.selectMonth,
    });
  const [deleteOverride] = useDeleteOverrideMutation();
  const newRowDetails = (rowDetails && rowDetails?.data) || [];

  const empOptions =
    fetchAllEmployees &&
    fetchAllEmployees.map((item) => ({
      value: item.empId,
      label: item.employeeName,
    }));

  const rows = newRowDetails?.map((item, index) => {
      return {
        id: item.date,
        empId: item.empId || "NA",
        employeeName: item.employeeName || "NA",
        date: dayjs(item.date).format("DD MMM, YYYY") || "NA",
        inTime: item.inTime || "00:00",
        outTime: item.outTime || "00:00",
        status: item.status || "NA",
        overriddenOn: item.overriddenOn || "NA",
        remarks: item.remarks || "NA",
      };
  });


  const columns = [
    { field: "empId", headerName: "Employee No" },
    { field: "employeeName", headerName: "Employee Name" },
    { field: "date", headerName: "Attendance Date" },
    { field: "inTime", headerName: "First In"},
    { field: "outTime", headerName: "Last Out"},
    { field: "status", headerName: "Status"},
    { field: "overriddenOn", headerName: "Override On"},
    {field: "remarks", headerName: "Remarks"},
  ];


  const handleReset = (resetForm) => {
    resetForm({
      values: {
        selectMonth: dayjs(),
        selectEmployee: "",
      },
    });
  };

  useEffect(() => {
    if (changeValue?.selectMonth && changeValue?.selectEmployee) {
      refetch();
    }
  }, [changeValue, refetch]);
  useEffect(() => {
    if (rowDetails) {
      setStateData(rowDetails);
      setDataTableKey((prev) => prev + 1);
    }
  }, [rowDetails]);

  const handleSelectedRows = (selectedData) => {
    setSelectedRows(selectedData);
  };
  
  const handleSubmit = async () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one row to delete.");
      return;
    }
  
    const payload = selectedRows.map((row) => ({
      empId: row.empId,
      yearMonth: moment(changeValue.selectMonth, ["MM-YYYY", "YYYY-MM"]).format("MM-YYYY"),
      attendanceDate: moment(row.id).format("YYYY-MM-DD"),
    }));
      
    try {
      await deleteOverride({formData: payload}).unwrap();
      toast("success", "Override entries deleted successfully!");
      await refetch(); 
      setSelectedRows([]); 
      handleSelectedRows([]);
    } catch (error) {
      // toast.error(error?.data?.message || "Something went wrong while deleting.");
    }
  };
  


  return (
    <Box>
      
      <Formik
        initialValues={{
          selectEmployee: "",
          selectMonth: dayjs(),
        }}
        onSubmit={(values) => { }}
      >
        {({ resetForm, values, isSubmitting }) => {
          const formattedMonth = values.selectMonth
            ? moment(values.selectMonth).format('MM-YYYY')
            : "";
          useEffect(() => {
            setChangeValue({
              ...values,
              selectMonth: formattedMonth,
            });
          }, [values, formattedMonth]);
          return (
            <Form>
              <Grid container spacing={2} marginBottom={2}>
                <Grid item xs={12} sm={4}>
                  <FormikSelectInput
                    name="selectEmployee"
                    label="Select Employee"
                    required
                    placeholder="Select Employee"
                    options={empOptions}
                    search={true}
                    rows={1.5}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormikMonthYearPicker
                    name="selectMonth"
                    label="Select Month"
                    required
                    pickerType="month"
                    placeholder="Select To Month"
                    rows={1.5}
                    maxDate={new Date()}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={4}
                  mt={3.5}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    sx={{
                      width: "100px",
                      height: "40px",
                      mr: 2,
                    }}
                    variant="outlined"
                    color="error"
                    size="medium"
                    onClick={() => handleReset(resetForm)}
                  >
                    Reset
                  </Button>
                  {selectedRows.length > 0 && (
                    <StyledButton
                      sx={{
                        width: "100px",
                        height: "40px",
                        mr: 2,
                      }}
                      variant="contained"
                      onClick={handleSubmit}
                      type="button"
                      label={isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                    />
                  )}
                </Grid>


              </Grid>
            </Form>
          );
        }}
      </Formik>

      <CommonDataTable
        columns={columns}
        rows={rows}
        checkbox={true}
        search={false}
        disableRowSelectionOnClick={true}
        selectedRows={selectedRows}
        onSelectedRowsChange={handleSelectedRows}
      />

        
    </Box>
  );
};

export default OverrideHistory;
